<template>
    <div class="lni-c-checkbox">
        <input
            :id="controlId"
            class="lni-c-checkbox__input"
            type="checkbox"
            :required="required"
            @change="handleErrorState"
            v-model="value" 
        />
        <label
            :for="controlId"
            class="lni-c-checkbox__label">
            <span>{{ labelText }}</span>
        </label>
    </div>

</template>

<script>
import framework from '../../framework';

/**
 *  The x-checkbox component.
 *  @module components/x-checkbox
 */


/**
 * The x-checkbox is a basic checkbox.
 */
export default {
    name: 'x-checkbox',
    props: {
        dataLabelText: String,
    },
    mixins: [
        framework.mixins.abstractSingleValueInput,
    ],
    mounted() {
        this.initialize();
    },
    computed: {
        labelText() {
            return this.getAttribute('labelText', '');
        },
    },
    methods: {
        /**
         * Put the values onto the Html Inputs
         * @returns {void}
         */
        initializeHtmlInputs() {
            if (this.componentValue) {
                let el = this.$el.querySelector(`input`);
                el.checked = this.componentValue === true;
            }
        },
        /**
        * Gets the error information off of the input element(s)
        * @returns {void}
        */
        getErrorStateOffInputs() {
            return this.getSimpleErrorStateOffInputs('input');
        },
    },
};
</script>
<style lang="scss">
    @import
        "../../styles/settings",
        "checkbox";
</style>



// WEBPACK FOOTER //
// source/components/x-checkbox/x-checkbox.vue